import {
  ErrorHandlingStrategy,
  QueryOperator,
  RuleActionType,
  RuleConditionType,
  RuleTriggerType,
} from "@redotech/redo-flows-common/rules/types";
import { SchemaType } from "@redotech/redo-flows-common/schemas/schemas";
import { StepType } from "@redotech/redo-flows-core-schema-common/common";
import { DefaultRule } from "../types";

export const closeInstagramStoryRepliesRule = {
  id: "default-close-instagram-story-replies",
  name: "Close Instagram story replies",
  hidden: false,
  triggerType: RuleTriggerType.CONVERSATION_CREATED,

  defaultConfig: {
    defaultRuleId: "default-close-instagram-story-replies",
    enabled: false,
    sortIndex: 13,
    configurations: {},
  },

  template: {
    name: "Close Instagram story replies",
    enabled: true,
    schemaType: SchemaType.RULES_V3,
    steps: [
      {
        type: StepType.TRIGGER,
        id: "trigger",
        schemaType: SchemaType.RULES_V3,
        category: "Rules",
        key: RuleTriggerType.CONVERSATION_CREATED,
        nextId: "conditions",
      },
      {
        type: StepType.RULE_CONDITIONS_V3,
        id: "conditions",
        conditionGroups: {
          operator: "AND",
          conditions: [
            {
              conditionType: RuleConditionType.TICKET_CHANNEL,
              channels: ["instagramDm"],
              queryOperator: QueryOperator.IS,
            },
            {
              conditionType: RuleConditionType.HAS_TAG,
              tags: ["instagram_story_reply"],
              queryOperator: QueryOperator.IS,
            },
          ],
        },
        nextTrueId: "actions",
      },
      {
        type: StepType.RULE_ACTIONS_V3,
        id: "actions",
        actions: [
          { actionType: RuleActionType.SET_STATUS_V3, status: "CLOSED" },
        ],
        errorHandlingStrategy: ErrorHandlingStrategy.FAIL_FAST,
      },
    ],
  },
} as const satisfies DefaultRule<string, Record<string, never>>;
